// extracted by mini-css-extract-plugin
export var container = "_3d-0";
export var icon = "_3d-1";